import React from "react";

const NAVY = "#0A316E";

// Sayaçlı kategori pill toggle grubu.
// tabs: [{ id, label, count }]
export default function CategoryTabs({ tabs, active, onChange }) {
    return (
        <div
            className="d-inline-flex align-items-center gap-2 p-1 bg-white shadow-sm flex-wrap"
            style={{ borderRadius: 999 }}
        >
            {tabs.map((t) => {
                const isActive = active === t.id;
                return (
                    <button
                        key={t.id}
                        type="button"
                        onClick={() => onChange(t.id)}
                        className="btn btn-sm d-inline-flex align-items-center gap-2 fw-semibold border-0"
                        style={{
                            borderRadius: 999,
                            padding: ".5rem 1rem",
                            backgroundColor: isActive ? NAVY : "transparent",
                            color: isActive ? "#fff" : "#5c6a86",
                            transition: "all .2s",
                        }}
                    >
                        {t.label}
                        <span
                            className="d-inline-flex align-items-center justify-content-center"
                            style={{
                                minWidth: 22,
                                height: 22,
                                borderRadius: 999,
                                fontSize: 12,
                                backgroundColor: isActive ? "rgba(255,255,255,.22)" : "#eef1f6",
                                color: isActive ? "#fff" : "#5c6a86",
                                padding: "0 6px",
                            }}
                        >
                            {t.count}
                        </span>
                    </button>
                );
            })}
        </div>
    );
}
